import { bool, func } from 'prop-types';
import cx from 'classnames';
import styles from './BranchArrowButton.scss';

export const BranchArrowButton = ({ expanded, onClick, className }) => {
  return (
    <button
      type="button"
      className={cx(
        className,
        expanded ? styles.branchArrow : styles.branchArrowCollapsed
      )}
      onClick={onClick}
    />
  );
};

BranchArrowButton.propTypes = {
  expanded: bool,
  onClick: func,
};
